<template >
  <v-col class="py-0">
    <v-row v-if="label">
      <b>{{ this.label }}</b>
    </v-row>
    <v-row v-if="loading || text">
      <p v-if="loading">loading...</p>
      <p v-else full-width v-html="text"></p>
    </v-row>
  </v-col>
</template>

<script>
import Description from '../field-types/Description.vue';

export default {
  name: 'RemoteDescription',
  extends: Description,
  data() {
    return {
      queryResult: null,
      loading: false,
      searchArguments: {},
    };
  },
  watch: {
    // this function watches the expressionInterpreter context
    // and will be called when this context had changed
    globalContext() {
      // the evalued interpreter params are apicges and filters
      // we supose an auto-update when, after eval old and new params,
      // those params are distinct
      const shouldUpdateComponent = ['apicges', 'filters']
        .filter((key) => this.params[key] && this.searchArguments[key])
        .map((key) => [key, this.evalParam(this.params[key])])
        .some((neweval) => {
          const newchanges = JSON.stringify(neweval[1]);
          const oldchanges = JSON.stringify(this.searchArguments[neweval[0]]);
          // console.log(this.$parent.alias, 'old', oldchanges, 'vs new', newchanges);
          return newchanges !== oldchanges;
        });

      if (shouldUpdateComponent) {
        // console.log(`updating ${ this.$parent.alias } component...`);
        this.updateQueryResult();
        this.$forceUpdate();
      }
    },
  },
  methods: {
    evalParam(param, v) {
      const str = typeof param === 'function' ? param({ value: v }) : param;
      try {
        return JSON.parse(str || '{}');
      } catch (ex) {
        return str;
      }
    },
    async search() {
      const {
        target, entity, fields = 'id,name', querysize,
        filters, apicges,
      } = this.params;

      /// updates the evalued params for auto-update detection
      const evaluedFilters = this.evalParam(filters);
      this.searchArguments.filters = JSON.parse(JSON.stringify(evaluedFilters));

      let evaluedApicges;
      if (apicges) {
        evaluedApicges = this.evalParam(apicges);
        this.searchArguments.apicges = evaluedApicges;
      }
      /// end

      let result;
      this.loading = true;

      try {
        result = await this.$api.getClient('search').search({
          target,
          entity,
          fields,
          apicges: evaluedApicges,
          filters: evaluedFilters,
          size: querysize,
        });
      } catch (ex) {
        console.error('error during search request', ex);
      }

      this.loading = false;
      return result;
    },
    async updateQueryResult() {
      const result = await this.search();
      if (result?.total > 0) {
        this.queryResult = result.list;
      } else {
        this.queryResult = [];
      }
      this.$emit('update:inputData', { item: { queryResult: this.queryResult } });
    },
  },
  async created() {
    this.updateQueryResult();
  },
  computed: {
    text() {
      const { text } = this.params;
      const { queryResult } = this;
      if (typeof text === 'function') {
        return text({ queryResult });
      }
      return text;
    },
    globalContext() {
      return this.$parent.expressionInterpreter.ctx;
    },
  },
};
</script>
